import React from 'react';

import {
  Container,
  Wrapper,
  Blurb,
  Headshot,
} from './styles';

import Social from '../Social';

const Header = () => (
  <Container>
    <Blurb>
      <Wrapper>
        <Headshot src="https://avatars1.githubusercontent.com/u/42190754?s=400&u=892f47c641d63a9a8855e510c82767e8e9e26aed&v=4" alt="" />
        <h1>Hi,</h1>
        <h1>I'm Bia Chacon,</h1>
        <h2>Developer Full-Stack.</h2>
        <Social />
      </Wrapper>
    </Blurb>
  </Container>
);

export default Header;